import axios, { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';
import { showToast } from "../components/Toast";
import { updateLoading } from '../store/reducers/loader';
const client = () => {
  const defaultOptions: AxiosRequestConfig = {
    headers: {},
  };
  const currentUrl = window.location.href;
  const isCoversure = currentUrl.includes('https://users.coversure.in');
  const API_BASE_URL = isCoversure ? "https://api.coversure.in" : "https://api.coversure.click"
  // Directly create the Axios instance here
  const API: AxiosInstance = axios.create({
    baseURL: API_BASE_URL, // Assuming you're using environment variables for the base URL
  });

  // Request Interceptor
  API.interceptors.request.use(
    (config: any) => {
      // const token = localStorage.getItem('auth');
      // if (token) {
        config.headers = {
          ...config.headers,
          Authorization: !isCoversure
          ? "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDb3ZlcnN1cmUgVG9rZW4iLCJleHAiOjE4MDc1NTQ2MDB9.gTztsh7AYNslQpnMxg1l_ub2MN4fzi7E266wI32WgTtY0lIo0r6WpIPc45mlGZsLCpecL_uMB-l8IZDHBLjutA"
          : "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDb3ZlcnN1cmUgVG9rZW4iLCJleHAiOjE4MjgxMTc4MDB9.ezwr5D6W2G_DRP1RU1Yy5P0XZoI3dq9p_9KYv0T1-6ucMxD_kXGQxGBGBpJ-Zk2f5cUUj1L2fF7VXNsMgTaIcg",
        };
      // }
      return config;
    },
    (error) => Promise.reject(error),
  );

  // Response Interceptor
  API.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error) => {
      const { response: { data: { message = '' } = {}, status = 0 } = {} } = error;
      if (status === 401) {
        // Auth Failed Logout
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.href = '/';
        showToast(message || 'Authentication failed. Please log in again.', "error");
      } else if (Math.floor(status / 100) === 4) {
        showToast(message || 'Client error occurred.', "error");
      } else if (Math.floor(status / 100) === 5) {
        // Server error
        showToast(message || 'Server error occurred. Please try again later.', "error");
      }
      return Promise.reject(error);
    },
  );

  return {
    get: (url: string, data?: any, options: AxiosRequestConfig = {}) =>
      API.get(url, { ...defaultOptions, ...options, params: data }),
    post: (url: string, data?: any, options: AxiosRequestConfig = {}) =>
      API.post(url, data, { ...defaultOptions, ...options }),
    patch: (url: string, data?: any, options: AxiosRequestConfig = {}) =>
      API.patch(url, data, { ...defaultOptions, ...options }),
    put: (url: string, data?: any, options: AxiosRequestConfig = {}) =>
      API.put(url, data, { ...defaultOptions, ...options }),
    delete: (url: string, options: AxiosRequestConfig = {}) =>
      API.delete(url, { ...defaultOptions, ...options }),
  };
};

export default client;
